import { Fragment } from "react";

import { CheckCircleOutlined } from "@ant-design/icons";
import { Dialog, Transition } from "@headlessui/react";

type Props = {
  title: string;
  open: any;
  setOpen: any;
  onClickAccept: any;
};

export default function SingleActionModal({
  title,
  open,
  setOpen,
  onClickAccept,
}: Props) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:h-screen sm:align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative inline-block w-[416px] transform overflow-hidden rounded-lg bg-white px-[32px] py-[32px] text-left align-bottom shadow-xl transition-all sm:align-middle">
                <div>
                  <div className="flex">
                    <div className="rounded-full text-green-600">
                      <CheckCircleOutlined style={{ fontSize: 22 }} />
                    </div>
                    <div className="ml-[16px] text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-header font-header leading-6 text-gray-900"
                      >
                        {title}
                      </Dialog.Title>
                    </div>
                  </div>
                </div>
                <div className="mt-5 flex justify-end sm:mt-6">
                  <button
                    type="button"
                    className={`focus:[#18A0FB] ml-2 inline-flex h-[32px] w-[52px] cursor-pointer items-center justify-center rounded border border-transparent bg-[#18A0FB] p-0 text-center text-button font-button text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2`}
                    onClick={onClickAccept}
                  >
                    Done
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
